module.exports = __webpack_public_path__ + "4b8107ad7c3a788ffccd261948dcc557.pdf";